var InputBase = require('../base');

var Radio = InputBase.extend( {
    create: function( inputOptions, $container ) {
        var self = this;
        var options = inputOptions.options 
            ? inputOptions.options.split( ';' ) : [], opt, items = [];
        for ( var i = 0; i < options.length; i++ ) {
            opt = options[i];
            items.push( {
                value: opt.split( ':' )[ 0 ],
                displayName: opt.split( ':' )[ 1 ]
            } );
        }
        this.bindData( items );
        this.$inp = $container;
        return $container;
    },
    getValue: function() {
        return this.$container.find( 'input:checked' ).attr( 'val' );
    },
    setValue: function( value ) {
        if (!value) {
            this.$container.find( 'input').prop('checked', false);
            return;
        }
        this.$container.find( 'input[val=' + value + ']' ).prop('checked', true);
        return this;
    },
    getDisplayName: function() {
        return this.$container.find( 'input:checked' ).next().text();
    },
    bindCheckEvent: function( eventName ) {
        
    },
    bindData: function( data ) {
        if (!data) return;
        
        var self = this;
        this.$container.html( '' );
        for ( var i = 0; i < data.length; i++ ) {
            this.$container.append(
                $('<input>').attr('type', 'radio')
                    .attr('name', this.contextInputId)
                    .attr('val', data[i].value)
                    .on('click', function(e) {
                        self.closeTips();
                        self.trig( 'Check' );
                    })
            ).append(
                $( '<label>' )
                    .text( data[i].displayName )
                    .click( function() {
                        $(this).prev().click();
                    } )
            )
        }
    }
} );

module.exports = Radio;



/*****************
 ** WEBPACK FOOTER
 ** ./src/input-factory/radio/index.js
 ** module id = 15
 ** module chunks = 0
 **/